(function () {
  var isTouch =
    "ontouchstart" in window ||
    (navigator.maxTouchPoints && navigator.maxTouchPoints > 0);

  console.log("[magiczoom-touch-fix] isTouch =", isTouch);

  if (!isTouch) return;

  var galleries = document.querySelectorAll("[data-gallery]");
  for (var g = 0; g < galleries.length; g++) {
    galleries[g].classList.add("photoswipe");
  }

  var links = document.querySelectorAll("a.MagicZoom");
  for (var i = 0; i < links.length; i++) {
    links[i].classList.remove("MagicZoom");
  }

  console.log(
    "[magiczoom-touch-fix] galleries switched to photoswipe =",
    galleries.length,
    "| MagicZoom links neutralized =",
    links.length
  );
})();
